import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { HELPDESK_TOOLKIT_ENDPOINTS, HelpdeskToolkitEndpoints } from "../helpdesk-toolkit.tokens";

@Injectable()
export class HelpdeskToolkitApiService {
    constructor(
        private readonly http: HttpClient,
        @Inject(HELPDESK_TOOLKIT_ENDPOINTS) private readonly endpoints: HelpdeskToolkitEndpoints,
        private readonly router: Router,
        @Inject(DOCUMENT) private readonly document: Document
    ) {}

    public test(): Observable<void> {
        return this.http.get<void>(this.endpoints.test);
    }
}
